import React, { useCallback, useContext } from "react";
import { createClasses, Tab, Tabs } from "@bloomberg/media-ui-core";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import type { ChartDateRange } from "@bloomberg/octagon-shared";
import { ScreenContext } from "@foundation/screen";
import styles from "./styles.module.css";
import { useChartRange, WatchlistContext } from "~context/WatchlistContext";
import { BENCHMARK_CHART_TIME_RANGES } from "~constants";

export default function ComparisonChartTabs() {
  const selectedTab = useChartRange();
  const store = useContext(WatchlistContext);
  const {
    breakpoints: { largeDesktop },
  } = useContext(ScreenContext);

  const trackComparisonChartTabClick = useCallback(
    (tabTitle: string) => {
      trackClickEvent(
        `chart_${tabTitle}`,
        `chart_${tabTitle}`,
        "click",
        "engagement"
      );

      // Fetch chart data for the selected range
      if (store) {
        const { fetchComparisonChart } = store.getState();

        void fetchComparisonChart(tabTitle as ChartDateRange);
      }
    },
    [store]
  );

  return (
    <Tabs
      className={styles.tabs}
      size={largeDesktop ? "default" : "small"}
      variant="gliding"
      onTabSwitch={trackComparisonChartTabClick}
    >
      {BENCHMARK_CHART_TIME_RANGES.map((chartRange) => (
        <Tab
          key={chartRange}
          title={chartRange}
          isActive={selectedTab === chartRange}
          isDefault={selectedTab === chartRange}
        >
          <></>
        </Tab>
      ))}
    </Tabs>
  );
}
